import { render } from "./FateItemInformation.vue?vue&type=template&id=69742a5a"
import script from "./FateItemInformation.vue?vue&type=script&lang=js"
export * from "./FateItemInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__